export default {
  format: (date, utc) => {
    const d = new Date(date);
    const dateUTC = new Date(d.setHours(d.getHours() + utc));
    return `${dateUTC.getDate()}/${dateUTC.getMonth() + 1}/${dateUTC.getFullYear()}, ${dateUTC.getHours()}:${dateUTC.getMinutes()}:${dateUTC.getSeconds()}`;
  },
  getDate: () => {
    let newDate = new Date();
    return `${newDate.getDate()}/${newDate.getMonth() + 1}/${newDate.getFullYear()}`;
  },
  formatString: (date, location) => {
    const event = new Date(date);
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return event.toLocaleDateString(location, options);
  }
};